

exports.__esModule = true;

var _squid = require('squid');

var _model = require('components/xo-tracking/dist/model');

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryDirective', {
    tag: 'xo-password-recovery',
    template: _template2['default'],
    props: {
        token: {
            type: 'var'
        },
        onContinue: {
            type: 'var'
        },
        onPasswordRecovery: {
            type: 'var'
        },
        onLoad: {
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            var PAYPAL = window.PAYPAL;

            this.loaded = false;
            var postMessageHandler = function postMessageHandler(response) {
                (0, _angular.$timeout)(function () {
                    switch (response.event) {
                        case 'render':
                            if (response.pageName === 'authflow/password-recovery/done') {
                                _this.onPasswordRecovery();
                                _logger.$logger.info('checkout_fpti', {
                                    from: 'password_recovery',
                                    to: 'process_password_recovery'
                                });
                            } else if (response.pageName === 'authflow/password-recovery') {
                                _this.onLoad();
                                _this.loaded = true;
                                _logger.$logger.info('checkout_fpti', {
                                    from: 'password_recovery',
                                    to: 'prepare_password_recovery'
                                });
                            } else {
                                // Do nothing
                            }
                            break;
                        case 'passwordSetSuccess':
                            _this.onContinue();
                            break;
                        default:
                            break;
                    }
                });
            };

            this.loadPasswordRecoveryFlow = function () {
                var isHermesInsideIframe = _squid.$util.isIFrame();

                if (isHermesInsideIframe) {
                    _logger.$logger.info('MERCHANT_IFRAME_INTEGRATION');
                }
                var options = {
                    targetElement: document.getElementById('injectedPasswordRecovery'),
                    xhrRequest: isHermesInsideIframe,
                    iframePathname: '/authflow/password-recovery',
                    caller: 'secondaryIframe',
                    queryParams: {
                        'country.x': _squid.$locale.country,
                        'locale.x': _squid.$locale.getLocaleCode(),
                        'contextId': _this.token,
                        'correlationId': _model.$CalDataModel.getCalCorrId()
                    },
                    onPostMessage: postMessageHandler
                };

                if (_squid.$config.deploy.isLocal()) {
                    options.origin = 'https://' + _squid.$meta.stage;
                }

                if (PAYPAL && PAYPAL.unifiedLogin) {
                    PAYPAL.unifiedLogin.inject(options);
                }
            };

            (0, _angular.$timeout)(this.loadPasswordRecoveryFlow);
        }
    }
});

_squid.$Component;

_squid.$config;

_squid.$locale;

_squid.$meta;

_squid.$util;

_model.$CalDataModel;

_angular.$timeout;

_logger.$logger;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/password-recovery/directive.js
// module id = ./components/xo-login-components/src/password-recovery/directive.js
// module chunks = 1